<template>
  <!-- 高级查询 -->
  <Modal v-model="modal" :width="modalWidth" class-name="export-modal" :closable="false" :mask-closable="false">
    <div class="flow-modal-title" slot="header">
      <span style="font-size: 17px">{{ title }}</span>
      <span @click="closeModal()" style="position: absolute; right: 6px; cursor: pointer">
        <i class="ivu-icon ivu-icon-ios-close"></i>
      </span>
    </div>
    <div class="search-content">
      <p class="search-content-select"><span>已筛选条件：</span><Button type="error" @click="closeAll">清空</Button></p>
      <div class="search-content-select-main">
        <template v-for="(ele, order) in complexQueryConfigAll">
          <p
            class="select-content"
            v-if="item.searchValue || (item.opName == 'between' && (item.start || item.end))"
            v-for="(item, index) in ele.fields"
            closable
            style="display: flex; align-items: center; font-size: 14px !important"
          >
            <span style="min-width: 80px; display: inline-block; font-size: 14px" class="textOverflowBsp" :title="item.label"
              >{{ item.label }}:<i v-if="item.searchValue && !item.dicInfo" style="font-size: 16px">{{ item.searchValue }}</i>
              <i v-if="item.start"> {{ dayjs(item.start).format('YYYY-MM-DD HH:mm:ss') }}-</i><i v-if="item.end">{{ dayjs(item.end).format('YYYY-MM-DD HH:mm:ss') }}</i>
            </span>
            <!-- 字典 -->
            <s-dicgrid v-if="item.searchValue && item.dicInfo" disabled v-model="item.searchValue" :multiple="item.isDicMultiple" :dicName="item.dicInfo" />
            &nbsp;&nbsp;&nbsp;<Icon type="md-close-circle" @click="closeItem(order, index, item)" />
          </p>
        </template>
      </div>
      <Collapse v-model="searchType">
        <Panel :name="order + ''" v-for="(item, order) in complexQueryConfigAll">
          {{ item.groupName }}
          <div slot="content">
            <Form class="formbox" :label-width="labelWidth" @submit.native.prevent>
              <!-- <template v-for="(condi, idx) in item.fields"> -->
              <div class="searchBox" :class="'style' + comModelProps.queryLineNums" :key="order">
                <div v-for="(condi, idx) in item.fields" :key="idx" :style="{ width: condi.width && condi.width > 1 ? condi.width + '%' : '31%' }">
                  <FormItem :label="condi.description + '：'">
                    <slot :name="condi.queryId" v-if="$scopedSlots[condi.queryId]" :condi="condi"></slot>
                    <template v-else>
                      <template v-if="condi.controlTypeName === '02' && (condi.dicType === '0' || condi.dicType === '1')">
                        <!--字典组件-->
                        <s-dicgrid v-model="condi.searchValue" style="width: 100%" ref="dicGrid" :key="idx" :multiple="condi.isDicMultiple" :dicName="condi.dicInfo" />
                      </template>
                      <template v-else-if="condi.controlTypeName === '02' && condi.dicType === '3'">
                        <!--字典组件(下拉框)-->
                        <Select v-model="condi.searchValue" style="width: 100%" :multiple="condi.isDicMultiple" clearable placeholder="请选择">
                          <Option v-for="item in condi.option" :value="item.key" :key="item.key">{{ item.text }}</Option>
                        </Select>
                      </template>
                      <template v-else-if="condi.controlTypeName === '13' && (condi.dicType === '0' || condi.dicType === '1')">
                        <!--多选组件-->
                        <data-checkbox v-model="condi.searchValue" style="width: 100%" ref="dicGrid" :key="idx" :multiple="condi.isDicMultiple" :dicName="condi.dicInfo" />
                      </template>
                      <template v-else-if="condi.controlTypeName === '12' && (condi.dicType === '0' || condi.dicType === '1')">
                        <!--单选组件-->
                        <data-radio v-model="condi.searchValue" style="width: 100%" ref="dicGrid" :key="idx" :multiple="condi.isDicMultiple" :dicName="condi.dicInfo" />
                      </template>

                      <template v-else-if="condi.controlTypeName === '03' && condi.opName === 'between'">
                        <!--日期组件-->
                        <Row>
                          <Col span="11">
                            <el-date-picker
                              popper-class="DataGrid-BOX"
                              :picker-options="pickerOptions(condi, 1)"
                              style="width: 100%"
                              :format="condi.format"
                              value-format="yyyy-MM-dd"
                              size="small"
                              v-model="condi.start"
                              type="date"
                              placeholder="开始日期"
                            ></el-date-picker>
                          </Col>
                          <Col span="2" style="text-align: center" class="timeTextzhi">至</Col>
                          <Col span="11">
                            <el-date-picker
                              popper-class="DataGrid-BOX"
                              :picker-options="pickerOptions(condi, 2)"
                              style="width: 100%"
                              :format="condi.format"
                              value-format="yyyy-MM-dd"
                              size="small"
                              v-model="condi.end"
                              type="date"
                              placeholder="结束日期"
                            ></el-date-picker>
                          </Col>
                        </Row>
                      </template>
                      <template v-else-if="condi.controlTypeName === '03'">
                        <!--日期组件-->
                        <el-date-picker
                          popper-class="DataGrid-BOX"
                          :format="condi.format"
                          style="width: 100%"
                          value-format="yyyy-MM-dd"
                          size="small"
                          v-model="condi.searchValue"
                          type="date"
                          placeholder="选择日期"
                        ></el-date-picker>
                      </template>
                      <template v-else-if="condi.controlTypeName === '04' && condi.opName === 'between'">
                        <!--日期时间组件-->
                        <Row>
                          <Col span="11">
                            <el-date-picker
                              popper-class="DataGrid-BOX"
                              @change="compareDateTime(condi, 1)"
                              style="width: 100%"
                              :format="condi.format"
                              :value-format="condi.format"
                              size="small"
                              v-model="condi.start"
                              type="datetime"
                              placeholder="开始时间"
                            ></el-date-picker>
                          </Col>
                          <Col span="2" style="text-align: center" class="timeTextzhi">至</Col>
                          <Col span="11">
                            <el-date-picker
                              popper-class="DataGrid-BOX"
                              @change="compareDateTime(condi, 2)"
                              style="width: 100%"
                              :format="condi.format"
                              :value-format="condi.format"
                              size="small"
                              v-model="condi.end"
                              type="datetime"
                              placeholder="结束时间"
                            ></el-date-picker>
                          </Col>
                        </Row>
                      </template>
                      <template v-else-if="condi.controlTypeName === '04'">
                        <!--日期时间组件-->
                        <el-date-picker
                          popper-class="DataGrid-BOX"
                          style="width: 100%"
                          :format="condi.format"
                          :value-format="condi.format"
                          size="small"
                          v-model="condi.searchValue"
                          type="datetime"
                          placeholder="选择时间"
                        ></el-date-picker>
                      </template>
                      <template v-else-if="condi.controlTypeName === '07'">
                        <!--月份组件(普通)-->
                        <el-date-picker
                          popper-class="DataGrid-BOX"
                          :format="condi.format"
                          style="width: 100%"
                          value-format="yyyy-MM"
                          size="small"
                          v-model="condi.searchValue"
                          type="month"
                          placeholder="选择月份"
                        ></el-date-picker>
                      </template>
                      <template v-else-if="condi.controlTypeName === '08'">
                        <!--区域组件(普通)-->
                        <sd-area-select-new ref="refCascader" style="width: 100%" v-model="condi.searchValue" />
                      </template>
                      <template v-else-if="condi.controlTypeName === '09'">
                        <!--机构组件(普通)-->
                        <sd-cascader ref="sdCascader" style="width: 100%" v-model="condi.searchValue" />
                      </template>
                      <template v-else-if="condi.controlTypeName === '10'">
                        <!--单位组件(普通-多选)-->
                        <sd-area-tree-select-new ref="refSdTreeSelect" style="width: 100%" v-model="condi.searchValue" />
                      </template>
                      <template v-else-if="condi.controlTypeName === '11'">
                        <!--案由组件(普通)-->
                        <sd-ay-tree-select ref="refSdAyTreeSelect" :ajlx="params.ajlx ? params.ajlx : '02'" style="width: 100%" v-model="condi.searchValue" />
                      </template>
                      <template v-else-if="condi.opName === 'between'">
                        <!--范围查询-->
                        <Row>
                          <Col span="11">
                            <Input @on-enter="query_grid_data(1)" style="width: 100%" v-model="condi.start" :key="idx" placeholder="输入起始值" />
                          </Col>
                          <Col span="2" style="text-align: center" class="timeTextzhi">至</Col>
                          <Col span="11">
                            <Input @on-enter="query_grid_data(1)" style="width: 100%" v-model="condi.end" :key="idx" placeholder="输入结束值" />
                          </Col>
                        </Row>
                      </template>
                      <template v-else>
                        <!--文本框-->
                        <Input
                          @on-enter="query_grid_data(1)"
                          style="width: 100%"
                          v-model="condi.searchValue"
                          :key="idx"
                          placeholder=""
                          @input.native="condi.triggerMethod == 'input' ? query_grid_data(1) : null"
                          @change.native="condi.triggerMethod == 'change' ? query_grid_data(1) : null"
                          @blur.native.capture="condi.triggerMethod == 'blur' ? query_grid_data(1) : null"
                        />
                      </template>
                    </template>
                  </FormItem>
                </div>
              </div>
              <!-- </template> -->
            </Form>
          </div>
        </Panel>
      </Collapse>
    </div>
    <div slot="footer" class="model-footer">
      <Button @click="closeModal">取消</Button>
      <Button type="primary" :loading="modal_loading" @click="confirmExport">立即检索</Button>
    </div>
  </Modal>
</template>

<script>
import dayjs from 'dayjs'
import dataCheckbox from './data-checkbox.vue'
import dataRadio from './data-radio.vue'
export default {
  name: 'grid-more-search',
  // mixins: [showFields, queryField, quickFilter, page, oper],
  components: { dataCheckbox, dataRadio },
  props: {
    modalWidth: {
      type: Number,
      default: 1200
    },
    modalHeight: {
      type: Number,
      default: 600
    },
    labelWidth: {
      type: Number,
      default: 120
    },
    gridAllShowFields: {
      type: Array,
      default() {
        return []
      }
    },
    complexQueryConfig: {
      type: Array,
      default() {
        return []
      }
    },
    queryFields: {
      type: Array,
      default() {
        return []
      }
    },
    modelId: {
      type: String,
      default: ''
    },
    rowMark: {
      type: String,
      default: ''
    },
    pageSize: {
      type: Number,
      default: 10
    },
    comModelProps: {
      type: Object,
      default() {
        return null
      }
    },
    gridRequestParams: {
      type: Object,
      default() {
        return null
      }
    },
    exportMaxCount: {
      type: Number,
      default: 2000
    },
    exportOption: {
      type: Object,
      default() {
        return {
          fileType: '0',
          exportFields: [],
          pageRange: {
            fromPageNo: 1,
            toPageNo: 1
          }
        }
      }
    }
  },
  computed: {
    pickerOptions() {
      let that = this
      return function (condi, type) {
        return {
          disabledDate(time) {
            if (type === 1) {
              if (condi.end) {
                let licenseEnd = new Date(condi.end)
                licenseEnd.setDate(licenseEnd.getDate())
                return time.getTime() >= licenseEnd
              } else {
                return false
              }
            } else {
              if (condi.start) {
                let licenseStart = new Date(condi.start)
                licenseStart.setDate(licenseStart.getDate() - 1)
                return time.getTime() <= licenseStart
              } else {
                return false
              }
            }
          }
        }
      }
    }
  },
  data() {
    return {
      dayjs: dayjs,
      modal: false,
      title: '高级查询',
      totalCount: 0,
      modal_loading: false,
      searchType: '0',
      complexQueryConfigAll: this.complexQueryConfig,
      searchData: []
    }
  },
  watch: {
    modal: {
      handler(n, o) {
        if (n) {
          if (this.comModelProps.allqueryFields.length > 0 && this.complexQueryConfig.length > 0) {
            this.complexQueryConfig.forEach(item => {
              if (item.fields && item.fields.length > 0) {
                item.fields.forEach(ele => {
                  this.comModelProps.allqueryFields.forEach(eleItem => {
                    if (ele.field == eleItem.name) {
                      ele = Object.assign(ele, eleItem)
                    }
                  })
                })
              }
            })
            this.complexQueryConfigAll = this.complexQueryConfig
            this.$forceUpdate()
          }
        }
      },
      deep: true,
      immediate: true
    },
    complexQueryConfigAll: {
      handler(n, o) {
        if (n) {
          this.searchData = []
          this.complexQueryConfigAll.forEach(ele => {
            if (ele.fields && ele.fields.length > 0) {
              ele.fields.forEach(item => {
                if (item.searchValue) {
                  let obj = {
                    name: item.name,
                    op: item.opName,
                    value: item.searchValue,
                    valueType: item.valueType,
                    label: item.label
                  }
                  this.searchData.push(obj)
                  const set = new Set()
                  // 去重核心代码
                  this.searchData = this.searchData.filter(item => {
                    // 若name未在Set中，返回true保留，同时将name加入Set；否则返回false过滤
                    return !set.has(item.name) && set.add(item.name)
                  })
                }
              })
            }
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {},
  methods: {
    closeItem(order, index, item) {
      if (item.searchValue) {
        this.$set(this.complexQueryConfigAll[order].fields[index], 'searchValue', '')
      } else if (item.opName == 'between') {
        this.$set(this.complexQueryConfigAll[order].fields[index], 'start', '')
        this.$set(this.complexQueryConfigAll[order].fields[index], 'end', '')
      }
    },
    closeAll() {
      this.complexQueryConfigAll.forEach(ele => {
        ele.fields.forEach(item => {
          if (item.searchValue) {
            this.$set(item, 'searchValue', '')
          } else if (item.opName == 'between') {
            this.$set(item, 'start', '')
            this.$set(item, 'end', '')
          }
        })
      })
    },
    closeModal() {
      this.modal = false
      this.$emit('closeModal')
    },
    query_grid_data(data) {
      this.$emit('query_grid_data', data)
    },
    confirmExport() {
      this.modal = false
      this.$emit('confirmSearch', this.complexQueryConfigAll)
    },
    compareDateTime(condi, type) {
      if (type === 2) {
        if (condi.start && condi.end) {
          if (condi.end < condi.start) {
            this.$Message['error']({
              background: true,
              content: '查询结束时间应大于开始时间'
            })
            condi.end = ''
          }
        }
      } else if (type === 1) {
        if (condi.end < condi.start) {
          if (condi.start && condi.end) {
            if (condi.end < condi.start) {
              this.$Message['error']({
                background: true,
                content: '查询开始时间应小于结束时间'
              })
              condi.start = ''
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.search-content-select {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-content-select-main {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.searchBox.style4 {
  display: flex;
  flex-wrap: wrap;
}
.select-content {
  background: linear-gradient(90deg, #115fc6, #56bbff);
  color: #fff;
  padding: 6px 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 6px;
  cursor: pointer;
  height: 42px;
  i {
    font-style: normal;
  }
}
.select-content /deep/ .sp-base,
.select-content /deep/ .sp-selected-tag {
  background: transparent !important;
  border: none !important;
  color: #fff !important;
  background-color: transparent !important;
}
.select-content div.v-selectpage div.sp-input-container div.sp-inputs span.sp-selected-tag {
  background-color: transparent !important;
}
.select-content /deep/ .sp-button {
  display: none !important;
}
.textOverflowBsp {
  white-space: nowrap;
  /* 禁止文本换行 */
  overflow: hidden;
  /* 隐藏超出范围的内容 */
  text-overflow: ellipsis;
  /* 使用省略号 */
}
.ivu-form-item {
  margin-bottom: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/component/data-grid/components/grid-more-search.vue